import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../../handleRequestThunk';
import {
    deletePlacement,
    editPlacement,
    getPlacement,
    updatePlacement,
} from '../placementThunks';
import { commonInitialState } from '../../../../../utils/common/commonInitialState';
const SLICE_NAME = 'placement';

export const placementSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getPlacement });
        handleRequestThunk({
            builder,
            request: deletePlacement,
            isDelete: true,
        });
        handleRequestThunk({ builder, request: editPlacement });
        handleRequestThunk({ builder, request: updatePlacement });
    },
});

export const placement = placementSlice.reducer;
